import {inject, injectable} from 'inversify';

import type {BaseDomainFactory} from '../Base/BaseDomain.factory';

import {ModelsRegistry} from '../../system/modelsRegistry/ModelsRegistry';
import {CourseModel} from './Course.model';

@injectable()
export class CourseFactory
  implements BaseDomainFactory<CourseModel, CourseModel.Props>
{
  constructor(
    @inject(ModelsRegistry)
    private readonly modelsRegistry: ModelsRegistry,
  ) {}

  create(props: CourseModel.Props): CourseModel {
    return this.modelsRegistry.put(new CourseModel(props));
  }
}
